import { Account } from './account';

export class Supplier extends Account {}
